import { render, staticRenderFns } from "./NewsListModal.vue?vue&type=template&id=5e9c2a60&scoped=true&"
import script from "./NewsListModal.vue?vue&type=script&lang=js&"
export * from "./NewsListModal.vue?vue&type=script&lang=js&"
import style0 from "./NewsListModal.vue?vue&type=style&index=0&id=5e9c2a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c2a60",
  null
  
)

export default component.exports